import { defaultListData, defaultListState } from 'bv-data'
import type { ListModel, ListModelState } from '@/types'
import { getQuery } from 'bv-utils'
import { listService } from '@/services/accountProcess/google'
import { putSave } from '@/models/utils'
import type { ReviewGoogleAccountInfo } from '@/services/accountProcess/google/review'
import type { GoogleTotalAccountInfo } from '@/services/accountProcess/google/total'

export const namespace = 'googleProcess'
export type GoogleProcessInfo = {

} & ReviewGoogleAccountInfo & GoogleTotalAccountInfo

export type GoogleProcessModelState = ListModelState<GoogleProcessInfo>;
export type GoogleProcessListModel = ListModel<GoogleProcessModelState>;

const listState: GoogleProcessModelState = { ...defaultListState, id: 0, type: '', selectedRows: [], selectedRowKeys: [] }

const model: GoogleProcessListModel = {
  namespace,
  state: listState,
  effects: {
    * list ({ params }, { call, put, select }) {
      const id: number = yield select((state: any) => state[namespace].id)
      const requestId = id + 1
      yield put(putSave({ id: requestId, type: params, loading: true }))
      const [ data, error ] = yield call(listService[params], getQuery())
      const currentId: number = yield select((state: any) => state[namespace].id)
      if (currentId === requestId) {
        yield put(putSave({  error,  data: data ?? defaultListData, loading: false }))
      }
    },
    * select ({ params = [] }, { put }) {
      yield put(putSave({  selectedRows: params, selectedRowKeys: params.map((item: any) => item.localId)  }))
    },
  },

  reducers: {
    clean (state) {
      return { ...state, ...defaultListState }
    },
    reset () {
      return listState
    },
    save (state, { payload = {} }) {
      return { ...state, ...payload }
    },
  },
}

export default model
